<script lang="ts">
  import { slide, type TransitionConfig } from "svelte/transition";
  import type { Product } from "../../helpers/types";
  import InputContainer from "../atoms/InputContainer.svelte";
  import PriceInfo from "../atoms/PriceInfo.svelte";
  import Specification from "../atoms/Specification.svelte";
  import HourlyPriceReminder from "./HourlyPriceReminder.svelte";

  interface Props {
    product: Product;
    selectedProduct: Product | undefined;
    productId: number;
    onClick: () => void;
  }

  interface SlideArgs {
    duration: number;
    animate: boolean;
  }

  let { product, selectedProduct = $bindable(), productId, onClick }: Props = $props();

  const hourlySlideIn = (node: Element, args: SlideArgs): TransitionConfig =>
    args.animate ? slide(node, args) : { duration: 0 };

  const hourlySlideOut = (node: Element, args: SlideArgs): TransitionConfig =>
    args.animate ? slide(node, args) : { duration: 0 };
</script>

<InputContainer
  {onClick}
  onChange={() => (selectedProduct = product)}
  checked={selectedProduct && selectedProduct.id == productId}
>
  <div class="flex flex-col sm:flex-row sm:justify-between">
    <div>
      <div>
        <span class="text-H3 mr-3">{product.name}</span>
        {#if product.recommended}
          <span class="tape-Green400 text-white text-H6 hidden sm:inline-block">REKOMMENDERAT</span>
        {/if}
      </div>
      {#if product.purchaseText}
        <div class="hidden md:block my-2 purchase-text">{@html product.purchaseText}</div>
      {/if}
    </div>
    {#if product && product.costs}
      <PriceInfo productType={product.type} costs={product.costs} />
    {/if}
  </div>
  <Specification showPreviousMonthInfo defaultOpen={false} {product} />
  {#if selectedProduct && productId && selectedProduct.id === productId}
    <div
      class="mt-4"
      in:hourlySlideIn={{
        duration: 300,
        animate: true,
      }}
      out:hourlySlideOut={{
        duration: 300,
        animate: true,
      }}
    >
      <HourlyPriceReminder />
    </div>
  {/if}
</InputContainer>
